// UID: NPO-HOA-DEL-FILE
// https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import loanFormModel from '../../form_models/loanFormModel';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import DelinquencyReportRuleset from '../../business/ruleset/DelinquencyReportRuleset';

const { delinquencyReport } = loanFormModel.formField.hoaDocuments;

export class DelinquencyReportValidation implements ValidationSchema {
  public name = delinquencyReport.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public ruleset = DelinquencyReportRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required)
      return FileNameValidationSchema(delinquencyReport.name, true).required(
        'This document is required'
      );
    return FileNameValidationSchema(
      delinquencyReport.name,
      false
    ).notRequired();
  }
}
export default new Validation(new DelinquencyReportValidation());
